<style></style>

<template>
    <div class="action-plan-list">
        <div  v-if="actionPlans.length == 0">
            <div class="alert alert-secondary" v-if="completedAssessments.length == 0">
                Before starting an action plan, finish your self-assessment and set goals. 
                If you have already taken your self-assessment, make sure that you clicked the “Finish &amp; View Results” button to submit it. 
                After viewing your results, you can select goals for action planning.
            </div>
            <div  v-if="completedAssessments.length > 0">
                <a :href="selectGoalsLink" class="btn btn-orange-blue text-white" v-if="auth.is('program-user')">Select Goals</a>
                <div class="alert alert-info" v-if="auth.is('ta-consultant')">
                    The program has not set any goals.
                </div>
            </div>
        </div>
        <div v-for="plan in actionPlans" 
             :key="plan.id"
        >
            <action-plan-list-item 
                :action-plan="plan"
                :module="module"
            ></action-plan-list-item>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import ActionPlanListItem from './ActionPlanListItem'


    export default {
        components: {
            ActionPlanListItem
        },
        props: {
            'module': {
                required: true,
                type: Object
            },
            'actionPlans': {
                required: true
            },
            'assessments': {
                required: true,
                type: Array
            }
        },
        data() {
            return {
                slugToClass: {
                    'child-nutrition': 'nutrition_upcoming',
                    'infant-and-child-physical-activity': 'physical_upcoming',
                    'breastfeeding-and-infant-feeding': 'infant_upcoming',
                    'outdoor-play-and-learning': 'outdoor_upcoming',
                    'farm-to-e-c-e': 'farm_upcoming',
                    'oral-health': 'oral_upcoming',
                    'screen-time': 'screen_upcoming',
                },
                auth: window.Auth
            }
        },
        computed: {
            completedAssessments: function () {
                return this.assessments.filter(ass => ass.finalized_at !== null)
            },
            latestCompletedAssessment: function () {
                return this.completedAssessments[this.completedAssessments.length-1];
            },
            selectGoalsLink: function () {
                if (!this.latestCompletedAssessment) {
                    return null;
                }
                return this.$basePath+'/action-plans/'+this.latestCompletedAssessment.survey.slug+'/'+this.latestCompletedAssessment.id+'/select-sections';
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
    .action-plan-list {
        font-size: 16px;
        line-height: 1.1em;
    }
</style>